module.exports = __webpack_public_path__ + "img/apuestas_cucuta.0a5317d.png";